import {useMutation, useQueryClient} from "react-query";
import {api} from "../api/api";
import {useResponseValidate} from "./useResponseValidate";
import {useAppDispatch} from "@/store";
import {removeValidations} from "@/store/slices/globaleSlice";

export const useApiMutation = ({onMutate, onError, onSettled, onSuccess, formName}) => {
    const dispatch = useAppDispatch()
    const {successValidate, errorValidate} = useResponseValidate()

    const client = useQueryClient();

    return useMutation(({route, data, headers = {}}) => {
        dispatch(removeValidations())
        return api.send({
            route,
            data,
            headers,
        }).then((res) => res.data)
    }, {
        async onMutate(newValue) {
            if (onMutate) {
                return onMutate(client, newValue)
            }
        },

        // ? Делаем откат, если возникла ошибка.
        onError: (error, values, rollback) => {
            errorValidate(error, formName)

            if (onError) {
                onError(error, values, rollback)
            }
        },
        onSuccess: (resp, variables, context) => {
            successValidate(resp)

            if (onSuccess) {
                onSuccess(client, resp, variables, context)
            }
        },
        async onSettled(_, error, newTodo) {
            /**
             * ? Не зависимо от сценария (успех/ошибка),
             * ? инвалидиурем данные по ключу в кеше для того,
             * ? чтобы query подтянуло свежие (настоящие) данные — мы ведь Optimistic Updates делаем!
             */

            if (onSettled) {
                onSettled(_, error, newTodo)
            }
        },
    });
}